export const SUBMIT_PAGE = 'SUBMIT_PAGE'
export const URL_LIST_PAGE = 'URL_LIST_PAGE'
export const ACCOUNT_LIST_PAGE = 'ACCOUNT_LIST_PAGE'

export const pages = {
	[SUBMIT_PAGE]: {to: '/', label: 'Submit', exact: true},
	[URL_LIST_PAGE]: {to: '/url-list', label: 'Url list'},
	[ACCOUNT_LIST_PAGE]: {to: '/account-list', label: 'Account list', isHidden: true}
}